import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const sessionLockedState = atom({
  key: "sessionLockedState",
  default: false,
  effects_UNSTABLE: [ocPersistAtom],
});

export const narrowMenuOpenedState = atom({
  key: "narrowMenuOpenedState",
  default: true,
  effects_UNSTABLE: [ocPersistAtom],
});

export const showDrawerTransitionState = atom({
  key: "showDrawerTransitionState",
  default: true,
  effects_UNSTABLE: [ocPersistAtom],
});
